import { FC } from 'react';

import { BottomMenuWrapper } from './BottomMenu.styles';
import { ResetButtonLink } from '../../Header.styles';

type Props = {
    signInUrl: string;
};

const BottomMenu: FC<Props> = ({ signInUrl }) => (
    <BottomMenuWrapper>
        <li>
            <ResetButtonLink
                variant="tertiary"
                href={signInUrl}
                data-testid="header-profile-sign-in"
                data-header-signin="/signin/?page_after_login={URL}&return_url={URL}&with_confirmation=true"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>sign in"
            >
                Sign in
            </ResetButtonLink>
        </li>
    </BottomMenuWrapper>
);

export default BottomMenu;
